<div class="main__inner-wrapper">
  @if (leftBannerNode | async; as item) {
    <div class="col-md-12 margin-control" [ngClass]="{'terms-of-sale-class': currentPage === 'SeqirusTermsofSale'}">
      <div class="terms_title">{{item.headline}}</div>
      <!-- <div class="terms_heading1" *ngIf="item.uid=='SeqirusuktermsOfConditionscomponent'">{{item.headline}}</div> -->
      @if (item?.subheadline) {
        <div class="terms_title">{{item.subheadline}}</div>
      }
      @if (item?.paragraphContent) {
        <div class="header_subtext" [innerHTML]="item.paragraphContent"></div>
      }
    </div>
  }
</div>